import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { FindCustomersGet } from '@app/services/customer.service';
import { getFindCustomersParams } from '../find-customers.params';

@Component({
    selector: 'tt-find-customers-grid',
    templateUrl: './find-customers-grid.component.html',
    styleUrls: ['./find-customers-grid.component.css'],
    standalone: false,
})
export class FindCustomersGridComponent implements OnInit {
    @Input()
    public page?: FindCustomersGet;

    @Input()
    public grid?: GridOptions;

    @Output()
    public gridChange = new EventEmitter<GridOptions>();

    public async readGrid(allowEmptySearch = false) {
        if (!this.page) return;

        const hasCustomerGroupFilter = !!this.page.custgrp_id && this.page.custgrp_id !== 'ALL';
        const waitForSearch = this.page.show_last_visited_customers !== '1' && !this.page.cust_name && !hasCustomerGroupFilter && !allowEmptySearch;

        if (!this.grid && waitForSearch) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_findcustomers.grid')
                .setLoadDataFunction({ method: 2575, parameters: () => getFindCustomersParams(this.page!) })
                .setSpecialFunc({ newTab: true })
                .setKendoConfig({ height: '100%', aggregate: true, pager: false, selectable: false, filterable: false });
            this.gridChange.emit(this.grid);
        } else {
            this.grid.gridfunc?.read();
        }
    }

    public async readAllCustomers() {
        if (!this.page) return;

        this.page.show_last_visited_customers = '0';
        await this.readGrid(true);
    }

    ngOnInit(): void {
        void this.readGrid();
    }
}
